export default {
  allFiles(state) {
    return state.companyFiles + state.myFiles;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filebox/getters.js